/** @jsx jsx */
import { jsx, css } from "@emotion/core"
import Linkify from "react-linkify"
import PropTypes from "prop-types"
import { Img } from "components/image"
import { displayTime, userRole } from "utils"
import { TEXT, PHOTO, FILE } from "../messageTypes"

// import customerImage from "../../../assets/images/avatar/avatar-customer.png"
import getechImage from "../../../assets/images/avatar/avatar-getech.jpg"

const Message = ({ message, chatUser, userInfo }) => {
  const { name, role } = userInfo
  const { CUSTOMER, CUSTOMER_PURCHASER } = userRole

  const liClassName = () => {
    if (role === CUSTOMER || role === CUSTOMER_PURCHASER) {
      return `chat ${
        name !== message.sender.name ? "chat-item" : "chat-item odd"
      }`
    }

    return `chat ${
      chatUser === message.sender.name ? "chat-item" : "chat-item odd"
    }`
  }

  const renderMsgInfo = () => {
    if (role === CUSTOMER || role === CUSTOMER_PURCHASER) {
      return name === message.sender.name ? (
        <div>
          <span className="msgInfo">{displayTime(message.createdAt)}</span>{" "}
          {/* <span className="msgInfo">{message.isRead ? "已讀" : ""}</span> */}
        </div>
      ) : (
        <div>
          <div className="msgInfo">{displayTime(message.createdAt)}</div>
        </div>
      )
    }

    return name !== message.sender.name ? (
      <div>
        <div className="msgInfo unselectable">
          {displayTime(message.createdAt)}
        </div>
      </div>
    ) : (
      <div>
        <span className="msgInfo unselectable">
          {displayTime(message.createdAt)}
        </span>{" "}
        <span className="msgInfo unselectable">
          {/* {message.isRead ? "已讀" : ""} */}
        </span>
      </div>
    )
  }

  const avatar = () => {
    if (role === CUSTOMER || role === CUSTOMER_PURCHASER) {
      return (
        name !== message.sender.name && (
          <img src={getechImage} alt={`${message.sender.name}'s profile pic`} />
        )
      )
    }

    return (
      chatUser === message.sender.name && (
        <div style={{ fontWeight: "bold" }}>{message.sender.name}</div>
      )
    )
  }

  const renderContent = (message) => {
    if (message.type === TEXT) {
      return (
        <div>
          <Linkify componentDecorator={componentDecorator}>
            {message.content}
          </Linkify>
        </div>
      )
    }

    if (message.type === PHOTO) {
      return <Img src={`http://${message.content}`} name={message.fileName} />
    }

    if (message.type === FILE) {
      return (
        <div>
          <i className=" fas fa-file" />{" "}
          <a
            href={`http://${message.content}`}
            css={linkCss}
            target="_blank"
            rel="noreferrer noopener"
          >
            {message.fileName}
          </a>
        </div>
      )
    }

    return null
  }

  return (
    <li className={liClassName()}>
      <div className="chat-img">{avatar()}</div>
      <div className="chat-content">
        <div
          className="box bg-light-info"
          css={linkCss}
          style={{
            borderRadius: "10px",
            backgroundColor:
              name !== message.sender.name ? "#26c6da" : "#26c6da"
          }}
        >
          {renderContent(message)}
        </div>
        <div css={infoCss}>{renderMsgInfo()}</div>
      </div>
    </li>
  )
}

// #region Handle css
const linkCss = css`
  a {
    color: blue;
  }
  a:hover {
    color: red;
  }
`

const infoCss = css`
  .msgInfo {
    font-size: smaller;
  }
`

const componentDecorator = (href, text, key) => (
  <a href={href} key={key} target="_blank" rel="noreferrer noopener">
    {text}
  </a>
)
// #endregion

Message.propTypes = {
  message: PropTypes.object.isRequired,
  chatUser: PropTypes.string,
  userInfo: PropTypes.object.isRequired
}

export default Message
